// Deal scenarios — each negotiation round uses one of these

const SCENARIOS = [
  {
    id: 'used_car',
    title: 'Used Car Deal',
    emoji: '🚗',
    description: 'A 2021 sedan with 35K miles. The seller seems motivated but knows the market.',
    context: 'Private sale. Car has minor cosmetic damage. KBB value is around $22,000.',
    playerRole: 'buyer',
    listPrice: 24000,
    playerTarget: 19500,
    opponentTarget: 21000,
    opponentFloor: 18500,
    timeLimit: 90,
    category: 'automotive',
    difficulty: 1,
  },
  {
    id: 'salary',
    title: 'Salary Negotiation',
    emoji: '💼',
    description: 'You\'ve received a job offer. The initial package is good but you know you\'re worth more.',
    context: 'Senior role at a tech company. Market rate is $140K-$175K. They offered $145K.',
    playerRole: 'seller',
    listPrice: 145000,
    playerTarget: 170000,
    opponentTarget: 155000,
    opponentFloor: 165000,
    timeLimit: 75,
    category: 'career',
    difficulty: 1,
  },
  {
    id: 'startup_deal',
    title: 'Startup Acquisition',
    emoji: '🦄',
    description: 'A tech giant wants to acquire your SaaS startup. This is the deal of a lifetime.',
    context: 'Your ARR is $2M. They\'re offering $15M. Similar companies sold for $18-25M.',
    playerRole: 'seller',
    listPrice: 15000000,
    playerTarget: 22000000,
    opponentTarget: 18000000,
    opponentFloor: 24000000,
    timeLimit: 120,
    category: 'business',
    difficulty: 3,
  },
  {
    id: 'apartment',
    title: 'Apartment Lease',
    emoji: '🏠',
    description: 'Prime downtown apartment. The landlord is firm but the unit has been vacant for 2 months.',
    context: 'Listed at $3,200/mo. Similar units go for $2,800-$3,100. You have leverage.',
    playerRole: 'buyer',
    listPrice: 3200,
    playerTarget: 2700,
    opponentTarget: 2950,
    opponentFloor: 2600,
    timeLimit: 60,
    category: 'real_estate',
    difficulty: 1,
  },
  {
    id: 'freelance',
    title: 'Freelance Contract',
    emoji: '💻',
    description: 'A Fortune 500 wants you for a 6-month project. They lowballed you hard.',
    context: 'They offered $80/hr. Your rate is $150/hr. Market rate is $120-$160/hr.',
    playerRole: 'seller',
    listPrice: 80,
    playerTarget: 145,
    opponentTarget: 115,
    opponentFloor: 135,
    timeLimit: 75,
    category: 'career',
    difficulty: 2,
  },
  {
    id: 'art_piece',
    title: 'Rare Art Auction',
    emoji: '🎨',
    description: 'A collector is selling a piece you\'ve wanted for years. Private negotiation.',
    context: 'Last appraisal: $45,000. The collector needs cash but knows its value.',
    playerRole: 'buyer',
    listPrice: 55000,
    playerTarget: 38000,
    opponentTarget: 47000,
    opponentFloor: 36000,
    timeLimit: 90,
    category: 'luxury',
    difficulty: 2,
  },
  {
    id: 'merger',
    title: 'Corporate Merger',
    emoji: '🏢',
    description: 'Two companies merging. You negotiate the equity split.',
    context: 'Your company is slightly smaller but has better tech. Fair split is 45-55%.',
    playerRole: 'seller',
    listPrice: 40,
    playerTarget: 52,
    opponentTarget: 47,
    opponentFloor: 54,
    timeLimit: 120,
    category: 'business',
    difficulty: 3,
    isPercentage: true,
  },
  {
    id: 'vintage_watch',
    title: 'Vintage Watch Trade',
    emoji: '⌚',
    description: 'A rare 1960s Omega Speedmaster. The dealer is shrewd but you know watches.',
    context: 'Listed at $18,000. Comparable sales: $13,000-$16,000. Some patina issues.',
    playerRole: 'buyer',
    listPrice: 18000,
    playerTarget: 12500,
    opponentTarget: 15000,
    opponentFloor: 11500,
    timeLimit: 75,
    category: 'luxury',
    difficulty: 2,
  },
  {
    id: 'hostage',
    title: 'Hostage Negotiation',
    emoji: '🚨',
    description: 'High-stakes crisis. A disgruntled ex-employee holds demands. De-escalate.',
    context: 'They want $500K and safe passage. You need to get them below $200K and buy time.',
    playerRole: 'buyer',
    listPrice: 500000,
    playerTarget: 100000,
    opponentTarget: 300000,
    opponentFloor: 150000,
    timeLimit: 150,
    category: 'crisis',
    difficulty: 3,
  },
  {
    id: 'supplier',
    title: 'Bulk Supplier Deal',
    emoji: '📦',
    description: 'Negotiating annual supply contract. Volume gives you leverage.',
    context: 'Current price: $12/unit for 50K units. You want $8/unit. Market: $9-$11.',
    playerRole: 'buyer',
    listPrice: 12,
    playerTarget: 8,
    opponentTarget: 10,
    opponentFloor: 7.5,
    timeLimit: 90,
    category: 'business',
    difficulty: 2,
  },
];

export function getRandomScenario(excludeIds = []) {
  const available = SCENARIOS.filter(s => !excludeIds.includes(s.id));
  return available[Math.floor(Math.random() * available.length)] || SCENARIOS[0];
}

export function getScenariosByDifficulty(difficulty) {
  return SCENARIOS.filter(s => s.difficulty === difficulty);
}

export function formatPrice(value, scenario) {
  if (scenario?.isPercentage) return `${value}%`;
  if (Math.abs(value) >= 1e6) return `$${(value / 1e6).toFixed(1)}M`;
  if (Math.abs(value) >= 1e3) return `$${value.toLocaleString()}`;
  return `$${value}`;
}

export default SCENARIOS;
